import React from 'react'
import { func, object } from 'prop-types'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Form, PageHeader } from 'antd'
import { appendAnswer } from '~/states/modules/answer'
import { focusField } from 'states/modules/question'
import InputFactory from '../inputFactory'
import styles from './index.module.scss'

const FormFactory = ({
	initialValues = {},
	form,
	setRequesterData = () => {},
}) => {
	const dispatch = useDispatch()

	const { questions, visible, currentPage } = useSelector(
		({ question }) => ({
			questions: question.data,
			visible: question.visible,
			currentPage: question.currentPage,
			lastPage: question.lastPage,
		}),
		shallowEqual
	)

	const pageFieldsData = questions[currentPage]

	return (
		<Form form={form} layout="vertical" className={styles['form-content']}>
			{pageFieldsData && (
				<PageHeader className={styles.title}>{pageFieldsData.title}</PageHeader>
			)}
			{pageFieldsData && (
				<div className={styles['form']}>
					<InputFactory
						data={pageFieldsData.fields}
						setRequesterData={setRequesterData}
						visible={visible[currentPage]}
						form={form}
						initialValues={initialValues}
						currentFormStep={currentPage}
						onChange={() =>
							dispatch(
								appendAnswer({
									data: form.getFieldsValue(),
									pageFieldsData,
									visible: visible[currentPage],
								})
							)
						}
						onFocus={(variableName) => {
							dispatch(
								focusField({
									name: variableName,
								})
							)
						}}
					/>
				</div>
			)}
		</Form>
	)
}

export default FormFactory

FormFactory.propTypes = {
	initialValues: object,
	form: object,
	onCallAssistant: func,
	getEditor: func,
	setRequesterData: func,
}
